// extracted by mini-css-extract-plugin
module.exports = {"icon":"live-conversations__CloseMenuIcon__icon","iconSVG":"live-conversations__CloseMenuIcon__iconSVG"};